import { render } from "./SensorAlertsModal.vue?vue&type=template&id=5a54f128&scoped=true"
import script from "./SensorAlertsModal.vue?vue&type=script&lang=js"
export * from "./SensorAlertsModal.vue?vue&type=script&lang=js"

import "./SensorAlertsModal.vue?vue&type=style&index=0&id=5a54f128&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a54f128"]])

export default __exports__